export const selectSlug = (slug: string, translation: string): string => {
  if (slug === '') {
    return slug;
  }

  return translation;
};
